import GoldenRatioContainer from '../shared/GoldenRatioContainer';

const DisciplineRulesSkeleton = () => {
  return (
    <GoldenRatioContainer>
      <div className="card bg-base-100 shadow-sm rounded-2xl p-6 mb-6">
        <div className="flex flex-col gap-4">
          <div className="flex-1">
            <div className="h-8 bg-base-200 rounded skeleton animate-pulse w-64 mb-3"></div>
            <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-96"></div>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <div className="h-5 bg-base-200 rounded-full skeleton animate-pulse w-20"></div>
            <div className="h-5 bg-base-200 rounded-full skeleton animate-pulse w-20"></div>
            <div className="h-5 bg-base-200 rounded-full skeleton animate-pulse w-24"></div>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="card bg-base-100 shadow-sm rounded-2xl p-6">
            <div className="flex justify-between items-start mb-4">
              <div className="flex-1">
                <div className="h-6 bg-base-200 rounded skeleton animate-pulse w-1/3 mb-2"></div>
                <div className="h-4 bg-base-200 rounded skeleton animate-pulse w-2/3"></div>
              </div>
              <div className="h-8 w-8 bg-base-200 rounded skeleton animate-pulse"></div>
            </div>
            <div className="space-y-3">
              <div className="h-12 bg-base-200 rounded-lg skeleton animate-pulse"></div>
              <div className="h-12 bg-base-200 rounded-lg skeleton animate-pulse"></div>
            </div>
          </div>
        ))}
      </div>
    </GoldenRatioContainer>
  );
};

export default DisciplineRulesSkeleton;
